import * as React from 'react';
import {FunctionComponent, ReactNode} from 'react';
import {Link} from 'react-router-dom';

export interface CardProps {
    className?: string;
    children?: any;
    cardControls?: ReactNode;
    errorsChart?: any;
    footer?: any;
    id?: string;
    listControls?: any;
    subtitle?: string | null | undefined;
    title?: string | null | undefined;
    to?: string;
    onClick?: () => void;
}

export const Card: FunctionComponent<CardProps> =
    ({
         className,
         children,
         cardControls,
         errorsChart,
         footer,
         id,
         listControls,
         subtitle,
         title,
         to,
     }) => (
        <div className={`card ${className}`} id={id}>
            {(to !== undefined || title !== undefined) && (
                <div className="card-header">
                    <div className="flex items-center justify-between">
                        <h2 className="card-title">
                            {to && (
                                <Link className="text-m-green" to={to}>
                                    {title}
                                </Link>
                            )}
                            {to === undefined && title}
                        </h2>
                        {cardControls}
                    </div>
                    <h3 className="card-subtitle">{subtitle}</h3>
                    {listControls}
                    {errorsChart}
                </div>
            )}
            <div className="card-body">{children}</div>
            {footer && <div className="card-footer">{footer}</div>}
        </div>
    );
